(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('TypeTax', TypeTax);

    TypeTax.$inject = ['$resource'];

    function TypeTax ($resource) {
        var resourceUrl =  'api/type-tax/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryInclDeleted': {
                method: 'GET',
                isArray: true,
                params: {inclDeleted:true}
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
